import { ProductId } from './common';
import { getClientInfo } from './getClientInfo';
import { appInfo } from './appInfo';
//@ts-ignore
import md5 from 'js-md5';
//@ts-ignore
import * as nodeUuid from 'uuid';
/**
 * 获取用户token
 */
export function getUserToken() {
    return new Promise(function (resolve) {
        getClientInfo({
            forceUpdate: false,
            complete: function () {
                var userToken;
                switch (appInfo.productId) {
                    case ProductId.Ymstock:
                        userToken = {
                            emoneyToken: appInfo.token,
                            appId: appInfo.productId
                        };
                        if (appInfo.appVersion) {
                            userToken.mv = Number(appInfo.appVersion.replace(/\./g, ''));
                        }
                        if (appInfo.vd) {
                            userToken.vd = appInfo.vd;
                        }
                        var ar = appInfo.getParam('ar');
                        if (ar) {
                            userToken.ar = ar;
                        }
                        break;
                    case ProductId.Ycstock:
                        userToken = {
                            'Ykt-Token': appInfo.token
                        };
                        break;
                    default:
                        userToken = {
                            authorization: appInfo.token
                        };
                        if (appInfo.productId) {
                            userToken.appId = appInfo.productId;
                        }
                        break;
                }
                resolve(userToken);
            }
        });
    });
}
/**
 * 获取接口签名及用户token
 * 仅限有看投，直接返回有看投签名
 * @param onlyYcstock 默认为true，为false时请确保传入正确的productId（已调用getClientInfo），其他平台则只返回token
 */
export function getUserSign(onlyYcstock) {
    if (onlyYcstock === void 0) { onlyYcstock = true; }
    return new Promise(function (resolve, reject) {
        getClientInfo({
            forceUpdate: false,
            complete: function () {
                var userSign = undefined;
                function setUserSign() {
                    var HtmlApiKey = 'ykt.html';
                    var HtmlSecret = 'no.secret';
                    userSign = {
                        'Emapp-ApiKey': HtmlApiKey,
                        'Emapp-Timestamp': new Date().valueOf(),
                        'Emapp-Nonce': nodeUuid.v1(),
                        'Emapp-Sign': '',
                        'Ykt-Token': appInfo.token
                    };
                    var signStr = "" + userSign['Emapp-Nonce'] + userSign['Emapp-Timestamp'] + HtmlSecret;
                    userSign['Emapp-Sign'] = md5(signStr).toLowerCase();
                }
                if (onlyYcstock) {
                    setUserSign();
                }
                else {
                    switch (appInfo.productId) {
                        case ProductId.Ycstock:
                            setUserSign();
                            break;
                        case ProductId.Ymstock:
                            userSign = {
                                emoneyToken: appInfo.token
                            };
                            break;
                        default:
                            userSign = {
                                authorization: appInfo.token
                            };
                            break;
                    }
                }
                resolve(userSign);
            }
        });
    });
}
//# sourceMappingURL=getUserToken.js.map